// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"fd88f603","659":"22f5ac35"}[chunkId] + ".chunk.js";
};